// Generated by Melange

import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifierCard(Props) {
  let card = Props.card;
  return JsxRuntime.jsxs(Buhta_landing__Link.make, {
    route: {
      TAG: /* Landing */ 0,
      _0: /* COUNTRY_KAZ */ 1,
      _1: /* Ru */ 1,
      _2: {
        TAG: /* Classifiers */ 8,
        _0: card.route
      }
    },
    className: "w-64",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-5 h-[31px]",
                src: StaticAsset.src(card.bookmark)
              }),
              JsxRuntime.jsx("p", {
                children: card.title,
                className: Cn.$plus("caption-medium", card.color)
              })
            ],
            className: Cn.$plus(card.bg, "pl-6 pb-5 h-60 rounded-t-md flex flex-col justify-between")
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("h6", {
              children: card.name,
              className: "h6 text-black-landing"
            }),
            className: "bg-white rounded-b-md h-20 px-6 pb-5 flex items-end"
          })
        ],
        className: "rounded-md"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h4", {
            children: card.name,
            className: "h5 lg:h4 text-white text-center lg:text-left"
          }),
          JsxRuntime.jsx("p", {
            children: card.desc,
            className: "paragraph-small lg:paragraph text-white/40 mt-1 lg:mt-2 text-center lg:text-left"
          })
        ],
        className: "px-2 mt-4 lg:mt-5"
      })
    ]
  });
}

const make = ClassifierCard;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
